// Icon.tsx
import React, { useEffect } from 'react';
import { soundService } from './services/SoundService.ts';

interface IconProps {
  image: string;
  name?: string;
  onDoubleClick: () => void;
}

const Icon: React.FC<IconProps> = ({ image, name, onDoubleClick }) => {

  useEffect(() => {
    soundService.init();
  }, []);

  const handleDoubleClick = () => {
    soundService.playClickSound();
    onDoubleClick();
  };

  return (
    <div style={styles.icon} onClick={handleDoubleClick}>
      <img src={image} alt={name} style={styles.iconImage} />
      {name && <div className="iconText">{name}</div>}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  icon: {
    width: '128px',
    height: '160px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    userSelect: 'none',
    position: 'relative',
  },
  iconImage: {
    width: '75px',
    height: '75px',
    objectFit: 'contain',
    marginBottom: '0px', /* アイコン下のマージン */
  }
};

export default Icon;
